/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AttachPhoneStartRequest
 */
export interface AttachPhoneStartRequest {
    /**
     * 
     */
    token: string;
    /**
     * 
     */
    phone: string;
}

/**
 * Check if a given object implements the AttachPhoneStartRequest interface.
 */
export function instanceOfAttachPhoneStartRequest(value: object): value is AttachPhoneStartRequest {
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    return true;
}

export function AttachPhoneStartRequestFromJSON(json: any): AttachPhoneStartRequest {
    return AttachPhoneStartRequestFromJSONTyped(json, false);
}

export function AttachPhoneStartRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttachPhoneStartRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
        'phone': json['phone'],
    };
}

export function AttachPhoneStartRequestToJSON(json: any): AttachPhoneStartRequest {
    return AttachPhoneStartRequestToJSONTyped(json, false);
}

export function AttachPhoneStartRequestToJSONTyped(value?: AttachPhoneStartRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
        'phone': value['phone'],
    };
}

